import { Grid, Container } from "@mui/material";
import Instructions from "./Instructions";
import TestParameters from "./TestParameters";
import { TestReducer } from "../../types/test-types";

const TestSetup = (props: { testReducer: TestReducer }) => {
  return (
    <Container disableGutters>
      <Grid container>
        <Grid item xs={12} md={7} lg={7}>
          <Instructions userCode={props.testReducer.state.userCode} />
        </Grid>
        <Grid item xs={12} md={5} lg={5}>
          <TestParameters testReducer={props.testReducer} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default TestSetup;
